export default __webpack_public_path__ + "static/media/loading-frog-bitstray.14dcf0a7.gif";